"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_MAPPING = {
    prefix: 'templates',
    addTemplate: {
        path: '/addTemplate'
    },
    updateTemplate: {
        path: '/updateTemplate',
        parameter: '/:templateId'
    },
    getFakeStatementMessageTemplatePdf: {
        path: '/getFakeStatementMessageTemplatePdf',
        parameter: '/:templateId'
    },
    getTemplatePdf: {
        path: '/getTemplatePDF',
        parameter: '/:templateId'
    },
    getFilteredTemplates: {
        path: '/getFilteredTemplates'
    },
    getTemplateById: {
        path: '/getTemplateById',
        parameter: '/:templateId'
    },
    deleteTemplate: {
        path: '/deleteTemplate',
        parameter: '/:templateId'
    }
};
